export enum Contexts {
  ADMIN = "admin",
  CLIENT = "client",
  GUEST = "guest",
  USER = "user",
  // this should be used only with {withAccessToken: false}
  NO_CONTEXT = ""
}
